var React = require('react');

function FlagTo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.724H8.828A8.829 8.829 0 010 414.896V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.792a8.83 8.83 0 01-8.829 8.828z","fill":"#ff4b55","key":0}),React.createElement("path",{"d":"M194.206 256H8.828A8.829 8.829 0 010 247.172V97.104a8.829 8.829 0 018.828-8.828h185.379a8.829 8.829 0 018.828 8.828v150.069a8.829 8.829 0 01-8.829 8.827z","fill":"#f5f5f5","key":1}),React.createElement("path",{"fill":"#ff4b55","d":"M167.724 150.069h-44.138v-44.138H79.448v44.138H35.31v44.138h44.138v44.138h44.138v-44.138h44.138z","key":2})]);
}

FlagTo.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagTo;

FlagTo.default = FlagTo;
